<script setup lang="ts"></script>

<template>
  <div class="flex items-center my-6">
    <hr class="w-full" />
    <span class="mx-4 text-sm font-medium text-sage-500">{{ $t('modals.general_wording.contact.or') }}</span>
    <hr class="w-full" />
  </div>
  <div class="grid grid-cols-2 gap-8 text-blue-500 text-sm text-center">
    <slot name="book"> </slot>
  </div>
</template>
